import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController, AlertController } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { ConfigurationServices } from '../../../../configuration/services';
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';

/**
 * Generated class for the TpvTicketChangeTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-change-table',
  templateUrl: 'tpv-ticket-change-table.html',
})
export class TpvTicketChangeTablePage {

  public firestore;
  table_uid: any;
  table: any;
  selected_list: any;
  rooms: any;
  tables: any;
  selectedRoom: any;
  selectedTable: any;
  selected_table: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController) {
    this.firestore = firebase.firestore();
    this.table_uid = this.navParams.get('table_uid');
  }

  ionViewWillEnter() {
    this.init_items();
  }

  back() {
    this.navCtrl.pop();
  }

  async init_items() {
    //init vars
    this.table = [];
    this.rooms = [];
    this.tables = [];
    //get all
    this.table = await this.get_table(this.table_uid);
    this.selected_list = this.tpvServices.listSelectedTicket('name', this.globals.objectToArray(this.table.ticket.list));
    await this.get_rooms_and_each_tables();
  }

  //funcion que recupera la mesa con su contenido
  async get_table(table_uid) {
    var table;
    const schRef = this.firestore.collection('tables').doc(table_uid);

    await schRef.get().then(doc => {
      table = doc.data();
      table.UID = this.table_uid;
    });

    return table;
  }

  async get_rooms_and_each_tables() {


    const roomsRef = this.firestore.collection('rooms');

    await roomsRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var room = doc.data();
          room.UID = doc.id;
          this.get_tables_from_uid(room.UID);
          this.rooms.push(room);
        });
      });
  }

  async get_tables_from_uid(uid) {
    const tablesRef = this.firestore.collection('tables');

    await tablesRef.where('uid_room', '==', uid).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var table = doc.data();
          table.UID = doc.id;

          this.tables.push(table);
        });
      });
  }

  selectRoom(value) {
    this.selectedRoom = value;
    this.selectedTable = "";
  }

  selectTable(value) {
    this.selectedTable = value;
  }

  async move_to_selected_table() {
    if (this.selectedTable) {
      //recuperamos mesa seleccionada
      this.selected_table = await this.get_table(this.selectedTable);
      //caso hay contenido en el mesa seleccionada
      if (this.globals.objectToArray(this.selected_table.ticket.list).length >= 1) {
        //preguntar si unir
        await this.ask_what_to_do_with_move_table();
      } else {//caso no hay contenido
        await this.move_contento_to_selected_table();
      }

    } else {
      this.launch_toast_notification();
    }
  }

  async ask_what_to_do_with_move_table() {
    let alert = this.alertCtrl.create({
      title: 'Mover contenido de ' + this.table.name + ' a ' + this.selected_table.name,
      message: '¿Esta seguro que quieres mover todo a ' + this.selected_table.name + '? Ya tiene contenido dentro, si es asi se unirá el contenido.',
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.move_contento_to_selected_table();
          }
        }
      ]
    });
    alert.present();
  }

  async move_contento_to_selected_table() {
    //present loading
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: 'Moviendo a mesa seleccionada.'
    });
    loadingPopup.present();
    //caso tiene ticket sobreescribir
    if (this.selected_table.ticket.number) {
      await this.concat_content();
      this.tpvServices.cancelTicket('clean');

    } else {//caso no ticket unir contenido
      await this.concat_content();
      this.tpvServices.cancelTicket('clean');
    }
    //dimiss loading
    loadingPopup.dismiss();
    this.navCtrl.pop();
    this.navCtrl.pop();
  }

  async concat_content() {
    //concat con los las 2 listas
    var list;
    list = this.mergeObjects(this.globals.objectToArray(this.table.ticket.list), this.globals.objectToArray(this.selected_table.ticket.list));
    list = this.globals.objectToArray(list);
    for (var element of list) {
      element.variation_array = [];
    }
    if (this.selected_table.ticket.created_at == undefined) {
      this.selected_table.ticket.created_at = new Date();
    }
    if (this.selected_table.ticket.updated_at == undefined) {
      this.selected_table.ticket.updated_at = new Date();
    }
    if (this.table.notes == undefined) {
      this.table.notes = "";
    }
    //update
    await this.tpvServices.afs.collection('tables').doc(this.selectedTable).update({
      'customer': this.table.customer,
      'persons': this.table.persons,
      'state': 'close',
      'ticket': {
        'amount': this.selected_table.ticket.amount,
        'created_at': this.selected_table.ticket.created_at,
        'date': this.selected_table.ticket.date,
        'list': list,
        'number': this.selected_table.ticket.number,
        'payment': this.selected_table.ticket.payment,
        'payment_type': this.selected_table.ticket.payment_type,
        'tip': this.tpvServices.checkTip(this.selected_table.ticket.tip),
        'updated_at': this.selected_table.ticket.updated_at,
        'waiter': this.selected_table.ticket.waiter,
        'waiter_uid': this.selected_table.ticket.waiter_uid,
      },
      'notes': this.table.notes
    }).then(() => {
      //
    });
  }

  launch_toast_notification() {
    let toast = this.toastCtrl.create({
      message: 'Selecciona una mesa',
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  mergeObjects(array1, array2) {
    array1 = array1.concat(array2);
    return Object.assign({}, array1);

  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-change-table/tpv-ticket-change-table.ts